module.exports = __webpack_public_path__ + "img/illustration-login.c163d40c.svg";